import { ComponentType, ReactNode } from 'react';

export type TNotificationComponent = ComponentType<object & { notification: INotification }>;

export enum NotificationType {
  Standard = 'standard',
  Success = 'success',
  Warning = 'warning',
  Destructive = 'destructive',
  Premium = 'premium',
  Preview = 'preview',
}

export enum AsyncNotificationStatus {
  None = 'none',
  Pending = 'pending',
  Finished = 'finished',
}

export interface INotification {
  id: string;
  NotificationComponent: TNotificationComponent;
  status: AsyncNotificationStatus;
  dismiss: () => void;
  setStatus: (status: AsyncNotificationStatus) => void;
  setMessage: (message: TNotificationComponent) => void;
}

export type TNotificationOptions = Partial<{
  timeout: number;
  isAsync: boolean;
  persist?: boolean;
  increasedNotificationsSlots?: boolean;
}>;

export interface INotificatorContext {
  notifications: INotification[];
  notify: (message: ReactNode, options?: TNotificationOptions) => INotification;
  getNotificationById: (id: string) => INotification;
}

export enum NotificationStateActionType {
  Add,
  Remove,
  SetStatus,
  SetMessage,
}

export interface INotificationAction {
  type: NotificationStateActionType;
  payload: Partial<{
    increasedNotificationsSlots?: boolean;
    notification: INotification;
    id: string;
    status: AsyncNotificationStatus;
    NotificationComponent: TNotificationComponent;
  }>;
}
